// App-wide configurable properties for easy updates and overrides
export const APP_PROPERTIES = {
  PARTICIPANT_NAME_CHAR_LIMIT: 14,
  MAX_PARTICIPANTS:36,
  INITIAL_DEFAULTS: 6,
  SPINNER_NAME_CHAR_LIMIT: 32,
  RANDOM_NUMBER_MIN: -999999999,
  RANDOM_NUMBER_MAX: 999999999,
  MAX_NUM: 36, // Maximum number for binary options and color grid
  MAX_RANDOM_NUM: 36, // Maximum number for random number generation
  MAX_COLOR: 24, // Maximum number of colors for color swatches (should match colorOptions.length)
  // Base color for all pills (participant names, numbers, random numbers)
  // Update this to change pill color app-wide
  PILLS_COLOR: '#ccebff',
  PILLS_TEXT_COLOR: '#222',
  // Binary pills: alternating colors (e.g., Stay/Go)
  BINARY_PILLS_COLOR_EVEN: '#eff6ff', // light blue
  BINARY_PILLS_COLOR_ODD: '#fef2f2',  // light red
  BINARY_PILLS_TEXT_COLOR_EVEN: '#2563eb', // blue text
  BINARY_PILLS_TEXT_COLOR_ODD: '#dc2626',  // red text
};

export const MAX_SAVED_SPINNERS = 30; 